import Select, { components } from 'react-select';

const dropdownStyle = {
    option: (provided, state) => ({
        ...provided,
        display: "flex",
        color: state.isSelected ? "#fff" : "#272727"
    }),
    input: (provided) => ({
        ...provided,
        color: '#272727'
    }),
    control: (provided) => ({
        ...provided,
    })
};

const Dropdown = ({options, includeImages, disabled, value, placeholder, onChange, style}) => {
    return <Select
        className="dropdown"
        style={style}

        components={{Option: (props) => {
            return <components.Option {...props}>
                {includeImages && <img 
                    src={props.data.image}
                    style={{height: "20px", width: "20px", borderRadius: "50%", marginRight: "10px"}}
                />}
                {props.data.label}
            </components.Option>
        }}}
        
        isDisabled={disabled}
        value={value}
        placeholder={placeholder}
        onChange={onChange}

        styles={dropdownStyle}
        options={options}
    >

    </Select>
}

export default Dropdown